import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

import { AddressPoint, addressPointFragment } from './useAddressPointApi'

export interface CreateAddressPointResult {
  addressPoint: AddressPoint | null
  errors: { field: string; message: string }[]
  message: string
  success: boolean
}

export interface CreateAddressPointInput {
  address1?: string
  address2?: string
  attentionName?: string
  city?: string
  companyName?: string
  countryCode?: string
  facilityId?: string
  firstName?: string
  lastName?: string
  phoneNumber?: string
  state?: string
  zip?: string
}

export const useCreateAddressPointApi = (): UseMutationResult<
  CreateAddressPointResult,
  Error,
  CreateAddressPointInput
> => {
  const client = useGraphQLClient()

  const query = gql`
    mutation CreateAddressPoint($input: CreateAddressPointInput!) {
      createAddressPoint(input: $input) {
        addressPoint {
          ...addressPoint
        }
        errors {
          field
          message
        }
        message
        success
      }
    }
    ${addressPointFragment}
  `

  const mutationFn = (input: CreateAddressPointInput): Promise<CreateAddressPointResult> =>
    client
      .request<{ createAddressPoint: CreateAddressPointResult }>(query, { input })
      .then(({ createAddressPoint }) => createAddressPoint)

  return useMutation<CreateAddressPointResult, Error, CreateAddressPointInput>({ mutationFn })
}
